export const provinceData = {
  // US
  'US-CA': 838202,
  'US-FL': 720125,
  'US-GA': 324650,
  'US-MN': 105740,
  'US-NJ': 209342,
  'US-OR': 35339,
  'US-SC': 152970,
  'US-WV': 16942,
  'US-CT': 59241,
  'US-KS': 63938,
  'US-MS': 101678,
  'US-OK': 93346,
  'US-SD': 24876,
  'US-WI': 136379,
  'US-AL': 160477,
  // // 'US-TX': 49,
  'US-MD': 128204,
  'US-NY': 466908,
  'US-RE': 0,
  'US-TN': 205375,
  'US-VA': 152945,
  'US-CO': 74169,
  'US-GU': 2818,
  'US-HI': 12937,
  'US-KY': 74194,
  'US-MP': 75,
  'US-RI': 25596,
  'US-VI': 1321,
  'US-AK': 8752,
  'US-LA': 169044,
  'US-ME': 5565,
  'US-NH': 8731,
  'US-NV': 82916,
  'US-UT': 79439,
  'US-WY': 6770,
  'US-MT': 15347,
  'US-AZ': 221934,
  // 'US-TX': 103,
  'US-IN': 126946,
  'US-NE': 48757,
  'US-ND': 24364,
  'US-PA': 170224,
  'US-OH': 161299,
  'US-WA': 90663,
  'US-DE': 21466,
  'US-IL': 307705,
  'US-ID': 45082,
  'US-MA': 135957,
  'US-MI': 143877,
  'US-NC': 221258,
  'US-VT': 1821,
  'US-AR': 88071,
  'US-DC': 15652,
  'US-IA': 93805,
  'US-MO': 136327,
  'US-NM': 30947,
  'US-PR': 51737,
  'US-TX': 798569,

  // germany
  'DE-BY': 71034,
  'DE-NI': 21743,
  'DE-RP': 11499,
  'DE-BW': 52231,
  'DE-MV': 1333,
  'DE-SN': 7797,
  'DE-null': 887,
  'DE-BE': 16615,
  'DE-NW': 75671,
  'DE-HH': 8544,
  'DE-TH': 4260,
  'DE-BB': 4570,
  'DE-HB': 2805,
  'DE-ST': 2837,
  'DE-HE': 20662,
  'DE-SL': 3573,
  'DE-SH': 5076,

  // Canada
  'CA-AB': 19354,
  'CA-BC': 9956,
  'CA-MB': 2278,
  'CA-NB': 222,
  'CA-NL': 277,
  'CA-PE': 61,
  'CA-ON': 58202,
  'CA-TX': 13,
  'CA-NU': 0,
  'CA-NS': 1089,
  'CA-QC': 81914,
  'CA-NT': 5,
  'CA-SK': 1994,
  'CA-YT': 15,

  // Australia
  'AU-NT': 33,
  'AU-QLD': 1160,
  'AU-NSW': 4261,
  'AU-TAS': 230,
  'AU-VIC': 20247,
  'AU-SA': 472,
  'AU-WA': 690,
  'AU-ACT': 113,

  // Brazil
  'ac': 28818,
  'al': 88426,
  'es': 136590,
  'ba': 319981,
  'ce': 256764,
  'df': 197369,
  'am': 144492,
  'go': 224181,
  'br': 136590,
  'ap': 48963,
  'ma': 176995,
  'ms': 73027,
  'mt': 129038,
  'mg': 313032,
  'pb': 124315,
  'pe': 151139,
  'rn': 71898,
  'rs': 207706,
  'pr': 187729,
  'ro': 67181,
  'pa': 235948,
  'pi': 99960,
  'se': 78692,
  'rr': 51635,
  'sp': 1016755,
  'sc': 222652,
  'rj': 277439,
  'to': 69969
};
